import { Box, Grid, withStyles } from '@material-ui/core';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { destroy, initialize, submit } from 'redux-form';
import * as QuizzesActions from '../../redux/actions/quizzes.actions';
import * as AnswerActions from '../../redux/actions/answers.actions';
import * as ModalsActions from '../../redux/actions/modal.actions';
import * as UtilsActions from '../../redux/actions/utils.actions';
import { EDULAI_BLUE, EDULAI_ORANGE } from '../../styles/styleConsts';
import translations from '../../translations/i18next';
import SubmissionAnswerForm from '../Forms/SubmissionAnswerForm/SubmissionAnswerForm';
import MDButton from '../MDButton/MDButton';
import { buildStyles, CircularProgressbar } from 'react-circular-progressbar';
import IncrementalText from '../Text/IncrementalText';
import QuizFeedback from './QuizFeedback';
import QuizzUtils from '../../utils/QuizUtils/QuizUtils';
import SpeechController from '../SpeechSynthesizer/SpeechController';
import { isMobileBrowser } from '../../utils/utilsFunctions';

const styles = (theme) => ({
  root: {
    width: '100%',
    backgroundColor: 'white',
    borderRadius: 8,
    padding: 30
  },
  button: {
    marginRight: theme.spacing(1)
  },
  completed: {
    display: 'inline-block'
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    fontWeight: 'bold',
    textAlign: 'center'
  },
  buttonsDiv: {
    display: 'flex',
    alignItems: 'flex-end',
    flexGrow: 1,
    margin: 'auto',
    marginBottom: 30
  },
  innerContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  titleBox: {
    display: 'flex',
    gap: 20,
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 20,
    flexWrap: isMobileBrowser() ? 'wrap' : 'nowrap'
  },
  questionTitle: {
    margin: 0,
    width: isMobileBrowser() ? '100%' : 'auto',
    textAlign: 'left'
  }
});

const theme = createMuiTheme({
  palette: {
    primary: { 500: EDULAI_BLUE },
    seconday: '#009900'
  },
  typography: {
    fontFamily: 'Inter, Arial, sans-serif',
    useNextVariants: true
  }
});

class QuizSubmissionLinearStepper extends Component {
  constructor(props) {
    super(props);
    const {
      questions,
      answers: {
        data: { content: answersData }
      }
    } = props;

    const answered = _.map(answersData, (answer) => answer.questionId);
    let nextNotAnswered;
    if (!this.allStepsCompleted()) {
      const nextQuestion = _.min(
        _.filter(questions, (question) => !answered.includes(question.id)),
        ['id']
      );
      nextNotAnswered = _.findIndex(questions, { id: nextQuestion.id });
    } else {
      nextNotAnswered = questions.length - 1;
    }

    this.state = {
      activeStep: nextNotAnswered,
      isQuestionRendered: false,
      stopIncrementalText: false,
      isFeedbackShowed: false,
      stopSpeaking: false
    };
  }

  componentDidMount() {
    const {
      questions,
      dispatch,
      answers: {
        data: { content: answersData }
      }
    } = this.props;
    const selectedAnswer = _.find(answersData, { questionId: questions[this.state.activeStep].id });
    dispatch(destroy('SubmissionAnswerForm'));
    if (selectedAnswer) {
      dispatch(
        initialize('SubmissionAnswerForm', {
          answer: selectedAnswer.optionNumber
        })
      );
    }
  }

  onSubmitAnswerHandler(questionId, values) {
    const { questions } = this.props;
    const { activeStep } = this.state;
    const isLastAnswer = activeStep + 1 === questions.length;
    if (isLastAnswer) {
      this.onSubmitLastAnswer(questionId, values);
    } else {
      this.onSubmitAnswer(questionId, values);
    }
  }

  onSubmitAnswer = async (questionId, values) => {
    const {
      dispatch,
      answers: {
        data: { content: answersData }
      },
      quiz
    } = this.props;
    if (_.isEmpty(values)) {
      dispatch(
        ModalsActions.showModal('NO_ANSWER_SELECTED_ERROR_MODAL', {
          modalType: 'ERROR_ALERT',
          modalProps: {
            message: translations.t('submissions.noAnswerSelectedError')
          }
        })
      );
    } else {
      try {
        dispatch(UtilsActions.setSpinnerVisible(true));
        const currentAnswer = _.find(answersData, { questionId });
        if (currentAnswer) {
          await dispatch(AnswerActions.updateAnswer(questionId, values));
        } else {
          await dispatch(AnswerActions.createAnswer(questionId, values));
        }
        await dispatch(AnswerActions.fetchAnswers());
        dispatch(QuizzesActions.fetchQuizzAnswersAndSubmissions(quiz));
        this.containerDiv.scrollIntoView({ behavior: 'smooth' });
        dispatch(
          ModalsActions.showModal('ANSWER_SUBMIT_SUCCESS_MODAL', {
            modalType: 'SUCCESS_ALERT',
            modalProps: {
              message: translations.t('submissions.answerSubmitSuccess')
            }
          })
        );
        dispatch(destroy('SubmissionAnswerForm'));
        this.handleNext();
        dispatch(UtilsActions.setSpinnerVisible(false));
      } catch (error) {
        dispatch(
          ModalsActions.showModal('ANSWER_SUBMIT_ERROR_MODAL', {
            modalType: 'ERROR_ALERT',
            modalProps: {
              message: translations.t('submissions.answerSubmitError')
            }
          })
        );
        dispatch(UtilsActions.setSpinnerVisible(false));
      }
    }
  };

  onSubmitLastAnswer = async (questionId, values) => {
    const { dispatch, onFinishQuiz } = this.props;
    if (_.isEmpty(values)) {
      dispatch(
        ModalsActions.showModal('NO_ANSWER_SELECTED_ERROR_MODAL', {
          modalType: 'ERROR_ALERT',
          modalProps: {
            message: translations.t('submissions.noAnswerSelectedError')
          }
        })
      );
    } else {
      try {
        dispatch(UtilsActions.setSpinnerVisible(true));
        await dispatch(AnswerActions.createAnswer(questionId, values));
        onFinishQuiz();
        dispatch(destroy('SubmissionAnswerForm'));
      } catch (error) {
        dispatch(
          ModalsActions.showModal('ANSWER_SUBMIT_ERROR_MODAL', {
            modalType: 'ERROR_ALERT',
            modalProps: {
              message: translations.t('submissions.answerSubmitError')
            }
          })
        );
        dispatch(UtilsActions.setSpinnerVisible(false));
      }
    }
  };

  isCompleted = (questionId) => {
    const {
      answers: {
        data: { content: answersData }
      }
    } = this.props;
    return _.find(answersData, { questionId });
  };

  totalSteps = () => {
    const { questions } = this.props;
    return questions.length;
  };

  getCompleteSynthetizedText(questionNumber, questionTitle, questionDescription, options) {
    const language = this.props.selectedLanguage;

    return `${translations.t('submissions.question', {
      lng: language
    })} ${questionNumber} - ${questionTitle} - ${questionDescription} - ${translations.t('submissions.options', {
      lng: language
    })}: ${options.map((option) => option.value).join(', ')}`;
  }

  handleNext = () => {
    const {
      dispatch,
      questions,
      answers: {
        data: { content: answersData }
      }
    } = this.props;
    const { activeStep } = this.state;
    const nextQuestions = questions.slice(activeStep + 1);
    const answered = _.map(answersData, (answer) => answer.questionId);
    let nextNotAnswered;
    if (!this.allStepsCompleted()) {
      let nextQuestion = _.min(
        _.filter(questions, (question) => !answered.includes(question.id)),
        ['id']
      );
      if (!_.isEmpty(nextQuestions)) {
        const nextQuestionTemp = _.min(
          _.filter(nextQuestions, (question) => !answered.includes(question.id)),
          ['id']
        );
        if (nextQuestionTemp) {
          nextQuestion = nextQuestionTemp;
        }
      }
      nextNotAnswered = _.findIndex(questions, { id: nextQuestion.id });
    } else {
      nextNotAnswered = activeStep;
    }
    const selectedAnswer = _.find(answersData, { questionId: questions[nextNotAnswered].id });
    dispatch(destroy('SubmissionAnswerForm'));
    if (selectedAnswer) {
      dispatch(
        initialize('SubmissionAnswerForm', {
          ...selectedAnswer,
          answer: selectedAnswer.optionNumber
        })
      );
    }
    
    this.setState({
      activeStep: nextNotAnswered,
      isQuestionRendered: false,
      stopIncrementalText: false,
      stopSpeaking: false,
      isFeedbackShowed: false,
    });
  };

  handleBack = () => {
    this.setState({ activeStep: (prevActiveStep) => prevActiveStep - 1 });
  };

  allStepsCompleted = () => {
    const {
      questions,
      answers: {
        data: { content: answersData }
      }
    } = this.props;
    return questions.length === answersData.length;
  };

  onSubmitClick = () => {
    const { dispatch } = this.props;
    window.speechSynthesis.cancel();
    dispatch(submit('SubmissionAnswerForm'));
  };

  handleStopClick = () => {
    this.setState({ stopIncrementalText: true, stopSpeaking: true });
  };

  get isFeedbackVisible() {
    return (
      !this.state.isFeedbackShowed &&
      QuizzUtils.isQuizFeedbackVisible(this.state.activeStep, this.props.questions.length)
    );
  }

  render() {
    const { classes, questions } = this.props;

    const { activeStep } = this.state;
    const options =
      questions && questions[activeStep] && questions[activeStep].options
        ? _.map(_.sortBy(questions[activeStep].options.optionDTOS, ['optionNumber']), (option) => ({
            id: option.optionNumber,
            value: option.body
          }))
        : [];

    const isLastAnswer = activeStep + 1 === questions.length;
    const questionNumber = questions.indexOf(questions[activeStep]) + 1;
    const questionsTotalNumber = questions.length;
    const questionName = questions[activeStep].name || '';
    const questionBody = questions[activeStep].body || '';

    return (
      <MuiThemeProvider theme={theme}>
        {this.isFeedbackVisible ? (
          <QuizFeedback
            step={this.state.activeStep}
            questionsTotalNumber={questionsTotalNumber}
            onProceed={() =>
              this.setState({
                isFeedbackShowed: true
              })
            }
          />
        ) : (
          <div
            className={classes.root}
            ref={(c) => {
              this.containerDiv = c;
            }}
          >
            <div className={classes.innerContainer}>
              <Grid
                container
                justify="space-between"
                direction="row"
                alignContent="flex-start"
                style={{ position: 'relative' }}
              >
                {/** Question title */}
                <Box className={classes.titleBox}>
                  <h1 className={classes.questionTitle}>
                    {questionNumber} - {questionName}
                  </h1>
                  <SpeechController
                    questionNumber={questionNumber}
                    questionName={questionName}
                    questionBody={questionBody}
                    options={options}
                    stopSpeaking={this.state.stopSpeaking}
                  />
                  <MDButton
                    onClick={this.handleStopClick}
                    disabled={this.state.stopIncrementalText}
                    title={translations.t('submissions.showAllText')}
                    variant="outlined"
                    backgroundColor={EDULAI_ORANGE}
                    buttonStyle={{ height: 26, minWidth: 180 }}
                    titleStyle={{ color: this.state.stopIncrementalText ? 'rgba(0, 0, 0, 0.26)' : EDULAI_ORANGE }}
                    containerstyle={{ marginTop: 0 }}
                  />
                  <Box style={{ width: 70, height: 70 }}>
                    <CircularProgressbar
                      value={questionNumber}
                      maxValue={questionsTotalNumber}
                      text={`${questionNumber}/${questionsTotalNumber}`}
                      styles={{
                        ...buildStyles({
                          pathColor: EDULAI_BLUE,
                          textColor: EDULAI_BLUE
                        })
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
              {/** Question body */}
              <Box style={{ position: 'relative' }} onClick={this.handleStopClick}>
                <h3 className={classes.instructions} style={{ textAlign: 'left' }}>
                  <IncrementalText
                    text={questionBody}
                    onComplete={
                      !this.state.stopIncrementalText ? () => this.setState({ isQuestionRendered: true }) : null
                    }
                    complete={this.state.stopIncrementalText}
                    onClick={this.handleStopClick}
                  />
                </h3>
              </Box>
              {/** Options */}
              <SubmissionAnswerForm
                options={options}
                onSubmit={(values) => this.onSubmitAnswerHandler(questions[activeStep].id, values)}
                showOptions={this.state.isQuestionRendered}
                stopIncrementalText={this.state.stopIncrementalText}
                onClickOption={this.handleStopIncrementalText}
              />

              <MDButton
                title={translations.t(isLastAnswer ? 'submissions.concludeQuiz' : 'submissions.submitAnswer')}
                backgroundColor={EDULAI_BLUE}
                containerstyle={{
                  marginTop: 20,
                  marginBottom: 20,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
                onClick={this.onSubmitClick}
                buttonStyle={{ width: '30%' }}
              />
            </div>
          </div>
        )}
      </MuiThemeProvider>
    );
  }
}

const mapStateToProps = (state) => ({
  answers: state.answers,
  quiz: state.quizzes.selectedQuiz,
  selectedLanguage: state.utils.selectedLanguage
});

export default _.flow([connect(mapStateToProps), withStyles((muiTheme) => styles(muiTheme), { withTheme: true })])(
  QuizSubmissionLinearStepper
);
